module.exports = __webpack_public_path__ + "static/media/menu.586090eb.svg";